<template>
	<report-page
		get-url="/bo/report/datascience/activepolicies"
		title="Active policies export"
		export-filename="active_policies_export"
	/>
</template>

<script>

export default {
	name: 'DatascienceActivePoliciesExport',

};
</script>
